<template>
  <div>
    <vee-field
      v-if="!claim.usesSalaryFraction"
      v-slot="{ errors }"
      rules="required"
      :name="validationNameOrDefault"
    >
      <v-select
        v-model="claim.payingOrgs"
        multiple
        item-value="id"
        item-title="name"
        chips
        closable-chips
        :disabled="isDisabled"
        :items="availablePayingOrgs(claim)"
        :label="label"
        :error-messages="errors"
        name="payingOrgs"
        variant="outlined"
        density="compact"
        :placeholder="placeholderTextOrDefault"
        @update:model-value="$emit('paying-orgs-change')"
      >
        <template #append>
          <v-icon tag="span">
            mdi-menu-down
          </v-icon>
        </template>
      </v-select>
    </vee-field>
    <v-tooltip
      v-else
      location="top"
      color="black"
    >
      <template #activator="{ props }">
        <v-chip v-bind="props">
          {{ $t("payingOrgsPickerStrings.splitBySalaryFraction") }}
          <v-icon
            tag="span"
            class="ml-2"
          >
            info
          </v-icon>
        </v-chip>
      </template>
      <ul>
        <li
          v-for="(parts, orgId) in salaryFractions"
          :key="orgId"
          class="mb-1"
        >
          {{ $tc("payingOrgsPickerStrings.salaryFractionExplanation", parts, { org: getOrgNameByOrgId(orgId), parts, total: totalFractionsCount }) }}
        </li>
      </ul>
    </v-tooltip>
  </div>
</template>

<script>
import { filterAvailablePayingOrgs } from "@/utils/claim";
import { Field as VeeField } from "vee-validate";
import { getOrgDisplayName } from "@/utils/org";
import { mapGetters } from "vuex";

export default {
  name: "PayingOrgsPicker",
  components: {
    VeeField
  },
  props: {
    claim: {
      type: Object,
      required: true
    },
    configurationTypeProperty: {
      type: String,
      required: true
    },
    filterEnabledTypesFunc: {
      type: Function,
      required: true
    },
    claimTypeProperty: {
      type: String,
      required: true
    },
    validationName: {
      type: String
    },
    placeholderText: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  watch: {
    "claim.usesSalaryFraction"(val) {
      if (val) {
        this.claim.payingOrgs = this.salaryFractionOrgIds;
      } else {
        this.claim.payingOrgs = [];
      }
      this.$emit('paying-orgs-change', this.claim.payingOrgs);
    },
    salaryFractionOrgIds(val) {
      if (this.claim.usesSalaryFraction) {
        if (val) {
          this.claim.payingOrgs = val;
        } else {
          this.claim.payingOrgs = [];
        }
        this.$emit('paying-orgs-change', this.claim.payingOrgs);
      }
    }
  },
  computed: {
    ...mapGetters({
      salaryFractions: "application/salaryFractionsStore/fractions",
      currentApplicationOrgs: "application/currentApplicationStore/orgs",
      totalFractionsCount:
        "application/salaryFractionsStore/totalFractionsCount",
      salaryFractionOrgIds: "application/salaryFractionsStore/uniqueOrgIds"
    }),
    isDisabled() {
      if (this.disabled) {
        return true;
      }

      if (this.claim.usesSalaryFraction) {
        return true;
      }

      return !this.claim[this.claimTypeProperty];
    },
    placeholderTextOrDefault() {
      if (this.placeholderText) {
        return this.placeholderText;
      }

      return this.$t("claimPickersStrings.placeholders.payingOrgs");
    },
    validationNameOrDefault() {
      if (this.validationName) {
        return this.validationName;
      }

      return this.$t("claimPickersStrings.tableHeaders.payingOrgs");
    }
  },
  methods: {
    getOrgNameByOrgId(orgId) {
      orgId = parseInt(orgId, 10);

      const org = this.currentApplicationOrgs.find(x => x.id === orgId);

      if (org != null) {
        return getOrgDisplayName(org);
      }

      return "";
    },
    availablePayingOrgs(claim) {
      return filterAvailablePayingOrgs(
        claim,
        this.configurationTypeProperty,
        this.filterEnabledTypesFunc,
        this.claimTypeProperty
      ).map(x => ({ id: x.id, name: getOrgDisplayName(x) }));
    }
  }
};
</script>
